import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  icon: {
    width: theme.spacing(2.25),
    height: theme.spacing(2.25),
  },
  badge: {
    top: theme.spacing(0.5),
    right: theme.spacing(0.75),
    minWidth: theme.spacing(2.5),
    height: theme.spacing(2.5),
    borderRadius: '50%',
    fontSize: '0.75rem',
    fontWeight: 700,
    padding: 0,
    backgroundColor: theme.palette.error.main,
    color: theme.palette.common.white,
  },
}));

export default useStyles;
